export default function getPlayerShortName(player) {
    return `${player?.last_name || ''} ${player?.first_name || ''}`.trim();
}
